"use client";

import { c as _c } from "react/compiler-runtime";
import { formatFullDate } from "@/constants/constants";
import { BusRequest } from "@/types/busrequest";
import { format } from "date-fns";
import ArrowRight from "@/elements/Arrows/ArrowRight";
import ArrowLeft from "@/elements/Arrows/ArrowLeft";
import ArrowRoundtrip from "@/elements/Arrows/ArrowRoundtrip";
import Tooltip from "@/components/tooltip";
import { MdInfo } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { getIconForRequestCompanyType } from "@/utils/Utils";
type Props = {
  request: BusRequest;
  onClick: () => void;
};
export default function GroupRequestTableRow(t0) {
  const $ = _c(55);
  const {
    request,
    onClick
  } = t0;
  const {
    t
  } = useTranslation();
  const t1 = !!request.company;
  let t2;
  if ($[0] !== request.companyType || $[1] !== t1) {
    t2 = getIconForRequestCompanyType(request.companyType, t1);
    $[0] = request.companyType;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const icon = t2;
  const t3 = request.category + "-row";
  let t4;
  if ($[3] !== icon) {
    t4 = <div className="leading-none">{icon}</div>;
    $[3] = icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== request.company || $[6] !== request.companyName || $[7] !== request.companyType || $[8] !== request.email || $[9] !== t) {
    t5 = request.company || request.email ? request.companyName : t(`PROVIDER.COMPANYTYPE.${request.companyType}.TEXT`);
    $[5] = request.company;
    $[6] = request.companyName;
    $[7] = request.companyType;
    $[8] = request.email;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="leading-none">{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <td>{t4}{t6}</td>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== request.start.address.address) {
    t8 = request.start.address.address.split(",").map(_temp);
    $[16] = request.start.address.address;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="basis-1/3">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== request.category || $[21] !== request.start.date || $[22] !== request.transferType) {
    t10 = (request.transferType === "transferoneway" || request.transferType === "transfertwoway" || request.category !== "grouprequest") && <><div className="block text-normal leading-none">{format(request.start.date, formatFullDate)}</div><ArrowRight className="-mt-2" /></>;
    $[20] = request.category;
    $[21] = request.start.date;
    $[22] = request.transferType;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== request.end.date || $[25] !== request.transferType) {
    t11 = request.transferType === "transfertwoway" && <><div className="mt-1 block text-normal leading-none">{format(request.end.date, formatFullDate)}</div><ArrowLeft className="-mt-2" /></>;
    $[24] = request.end.date;
    $[25] = request.transferType;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== request.end.date || $[28] !== request.start.date || $[29] !== request.transferType) {
    t12 = request.transferType === "transfertour" && <><div className="block text-normal leading-tight">{format(request.start.date, formatFullDate)}</div><ArrowRoundtrip /><div className="block text-normal leading-tight">{format(request.end.date, formatFullDate)}</div></>;
    $[27] = request.end.date;
    $[28] = request.start.date;
    $[29] = request.transferType;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== request.transferType || $[32] !== t) {
    t13 = request.transferType && <Tooltip content={t(`MAIN.PAGE_TRAVELCOMPANY.TABLE.TOOLTIPS.grouprequest.TRANSFERTYPE.${request.transferType}`)} className="absolute -right-4 top-0 text-inherit hover:text-action"><MdInfo className="h-4 w-4" /></Tooltip>;
    $[31] = request.transferType;
    $[32] = t;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t13) {
    t14 = <div className="relative flex basis-40 flex-col items-center">{t10}{t11}{t12}{t13}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== request.end.address.address) {
    t15 = request.end.address.address.split(",").map(_temp2);
    $[39] = request.end.address.address;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t15) {
    t16 = <div className="basis-1/3">{t15}</div>;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t14 || $[44] !== t16 || $[45] !== t9) {
    t17 = <td className="flex flex-row items-center justify-around gap-4">{t9}{t14}{t16}</td>;
    $[43] = t14;
    $[44] = t16;
    $[45] = t9;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== request.participants) {
    t18 = <td className="text-center">{request.participants}</td>;
    $[47] = request.participants;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== onClick || $[50] !== t17 || $[51] !== t18 || $[52] !== t3 || $[53] !== t7) {
    t19 = <tr className={t3} onClick={onClick}>{t7}{t17}{t18}</tr>;
    $[49] = onClick;
    $[50] = t17;
    $[51] = t18;
    $[52] = t3;
    $[53] = t7;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  return t19;
}
function _temp2(s_0, i_0, arr_0) {
  return <div className="text-normal leading-tight" key={"end-addr-line-" + i_0}>{s_0} {arr_0.length > i_0 + 1 && <br />}</div>;
}
function _temp(s, i, arr) {
  return <div className="text-normal leading-tight" key={"start-addr-line-" + i}>{s} {arr.length > i + 1 && <br />}</div>;
}